import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var BLACK_MAP = ["美年大健康", "医疗", "医院", "医美", "医生", "体检", "口腔"];
import { isByteDanceMiniProgram } from "@ykz/ykz-util/platform";
import databus, { Origins } from "@ykz/ykz-http/core";
import { toQueryString, extend } from "@ykz/ykz-util/base";
// 根据关键字筛选列表 目前在抖音屏蔽
export var filterBlackItem = function filterBlackItem(arr, attr) {
  var finalArr = arr;
  if (isByteDanceMiniProgram()) {
    BLACK_MAP.forEach(function (item) {
      finalArr = finalArr.filter(function (e) {
        return !e[attr].includes(item);
      });
    });
  }
  // console.log('----------------', finalArr)
  // BLACK_MAP.forEach(item => {
  //   finalArr = finalArr.filter(e => !e[attr].includes(item))
  // })
  return finalArr;
};

// 是否云客赞微信小程序
function isYkzMiniprogram() {
  var ua = navigator.userAgent.toLowerCase();
  // android可以用ua判断，ios得用__wxjs_environment
  // 支付宝小程序内的 ua 中也包含 miniprogram，因此需要先排除
  return !/alipayclient/.test(ua) && /miniprogram/.test(ua) || isIos() && window.__wxjs_environment === "miniprogram";
}
function isIos() {
  var ua = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) {
    return true;
  } else if (/android/.test(ua)) {
    return false;
  }
}

// 是否百度小程序
function isSwanMiniProgram() {
  var ua = navigator.userAgent.toLowerCase();
  return /baiduboxapp/.test(ua);
}

/**
 * 获取商详页或酒景页链接
 * author:linjia
 * 不包含channel 以及酒景类型参数的特殊处理
 * product:{
 * cateId://产品类型，必传，注意：cateId不能设置为0
 * weChatId://产品所属公众号Id，必传
 * activityId://活动Id，活动产品建议传
 * goodsId://产品Id，产品详情页必传
 * isActivity://是否是活动，必传
 * hotelId://所属酒店Id，新客房产品需要传
 * hotelScenicId://所属酒景Id，酒景详情页需要传
 * topicId://专题Id，属于专题产品时需要传
 * }
 */
export function getProductLink(product, platform) {
  if (!platform || !isYkzMiniprogram() && !isByteDanceMiniProgram() && !isSwanMiniProgram()) {
    platform = "h5";
  }
  // 专题
  if (product.topicId && location.href.search(/(promoter\/taskDetails|commission\/timeLimitList)/) == -1) {
    product.cateId = 0;
  }
  var urlStr = "";
  var urlParams = new URLSearchParams(window.location.search);
  var simData = urlParams.get("simData") || null;
  var weChatId = product.weChatId || urlParams.get("weChatId") || "1";
  var isShop = sessionStorage.getItem("session_isShop") || null;
  var promotion = sessionStorage.getItem("isShop_promotion") || null;
  var _ref = JSON.parse(localStorage.getItem("shopping_mall_city")) || {},
    cityCode = _ref.cityCode;
  var mustTake = {
    simData: simData,
    weChatId: weChatId,
    isShop: isShop,
    promotion: promotion,
    cityCode: cityCode
  };
  switch (+product.cateId) {
    case 0:
      //专题
      urlStr = "/front/topic/topicIndex?" + toQueryString(_objectSpread(_objectSpread({}, mustTake), {}, {
        topicId: product.topicId
      }));
      // 这个页面没有小程序版的，platform置回h5
      platform = "h5";
      break;
    case 3: //票券
    case 4: //娱乐
    case 5:
      //会议室
      if (platform === "h5") {
        urlStr = "/front/index/ticketProductDetails?" + toQueryString(_objectSpread(_objectSpread({}, mustTake), {}, {
          goodId: product.goodsId,
          activityId: product.isActivity ? product.activityId : null
        }));
      } else if (platform === "mini") {
        urlStr = "/pages/productDetail/ticketProductDetail/index?" + toQueryString(_objectSpread(_objectSpread({}, mustTake), {}, {
          goodId: product.goodsId,
          activityId: product.isActivity ? product.activityId : null
        }));
      }
      break;
    case 6:
      //新客房
      urlStr = "/front/index/roomList?" + toQueryString(_objectSpread(_objectSpread({}, mustTake), {}, {
        hotelId: product.hotelId || null,
        activityId: product.isActivity ? product.activityId : null
      }));
      platform = "h5";
      break;
    case 7:
      //特产
      if (platform === "h5") {
        urlStr = "/front/index/specialDetails?" + toQueryString(_objectSpread(_objectSpread({}, mustTake), {}, {
          goodId: product.goodsId,
          activityId: product.isActivity ? product.activityId : null
        }));
      } else if (platform === "mini") {
        urlStr = "/pages/productDetail/specialDetail/index?" + toQueryString(_objectSpread(_objectSpread({}, mustTake), {}, {
          goodId: product.goodsId,
          activityId: product.isActivity ? product.activityId : null
        }));
      }
      break;
    case 8:
      //新门票
      if (platform === "h5") {
        urlStr = "/front/index/entranceTicketDetails?" + toQueryString(_objectSpread(_objectSpread({}, mustTake), {}, {
          goodId: product.goodsId,
          activityId: product.isActivity ? product.activityId : null
        }));
      } else if (platform === "mini") {
        urlStr = "/pages/productDetail/entranceTicketDetail/index?" + toQueryString(_objectSpread(_objectSpread({}, mustTake), {}, {
          goodId: product.goodsId,
          activityId: product.isActivity ? product.activityId : null
        }));
      }
      break;
    case 9:
      //微客房
      if (platform === "h5") {
        urlStr = "/front/index/entranceTicketDetails?" + toQueryString(_objectSpread(_objectSpread({}, mustTake), {}, {
          isRoom: 1,
          goodId: product.goodsId,
          activityId: product.activityId || null
        }));
      } else if (platform === "mini") {
        urlStr = "/pages/productDetail/entranceTicketDetail/index?" + toQueryString(_objectSpread(_objectSpread({}, mustTake), {}, {
          isRoom: 1,
          goodId: product.goodsId,
          activityId: product.activityId || null
        }));
      }
      break;
    case 10:
      //演出票类型
      urlStr = "/front/index/showTicketDetails?" + toQueryString(_objectSpread(_objectSpread({}, mustTake), {}, {
        goodId: product.goodsId,
        activityId: product.isActivity ? product.activityId : null
      }));
      platform = "h5";
      break;
    default:
      console.log("cateId错误");
      return false;
  }
  //添加广告系统锚点数据到url hcz
  var adLinkStorage = "";
  if (sessionStorage.getItem("adLinkStorage") != null) {
    adLinkStorage = toQueryString(JSON.parse(sessionStorage.getItem("adLinkStorage")));
    urlStr = urlStr + "&" + adLinkStorage;
  }
  if (platform === "h5") {
    return location.protocol + "//" + location.host + urlStr + "&";
  } else if (platform === "mini") {
    return urlStr + "&";
  }
}
export var updateLocation = function updateLocation(options) {
  var urlMap = {
    user: "/apiv2/user/updateUserLocation",
    promoter: "/apiv2/marketing/updatePromoterLocation"
  };
  // console.log(urlMap,'urlMapurlMapurlMap');
  // return
  // todo getUserLocationInfo方法修改兼容promise后改为then
  // getUserLocationInfo().done(function (locationObject) {
  //     console.warn(locationObject);
  var locationObject = null;
  var switchLocInfo = JSON.parse(localStorage.getItem("shopping_mall_city"));
  if (switchLocInfo) {
    // 切换地址的缓存
    locationObject = {
      province: switchLocInfo.provinceName,
      city: switchLocInfo.cityName,
      district: switchLocInfo.districtName || "全部"
    };
  } else {
    // 定位的缓存
    var locInfo = JSON.parse(localStorage.getItem("KEY_CACHE_YCF_LOC_INFO"));
    locationObject = locInfo;
  }
  executeAjax(locationObject);

  // });
  var _result;
  function executeAjax(locationObject) {
    var defOptions = {
      type: "post",
      url: urlMap[options.status] || urlMap["user"],
      origin: Origins.API,
      data: {
        // longitude: locationObject.longitude,
        // latitude: locationObject.latitude,
        province: locationObject.province,
        city: locationObject.city,
        district: locationObject.district ? locationObject.district : "全部",
        street: "",
        locationType: 8,
        source: 0
      }
    };
    // // 定位方式，供接口端判断当前定位数据是否有效
    // options.data.locationMode = (() => {
    //   //定位服务来源，wx ykzApp baidu gaode
    //   let _apiSource = locationObject._apiSource;
    //   //定位使用的api方法： getLocation【wx】，getLocation【ykzApp】，Geolocation【baidu】，LocalCity【baidu】，getCityInfo【gaode】
    //   let _apiMethod = locationObject._apiMethod;
    //   if (_apiSource == "wx") {
    //     return "wx";
    //   }
    //   if (_apiSource == "ykzApp") {
    //     return "app";
    //   }
    //   if (_apiSource == "baidu" && _apiMethod == "LocalCity") {
    //     return "baiduLocalCity";
    //   }
    //   // 若都不符合，返回空字符串
    //   return "browser";
    // })();
    var parameter = extend(true, defOptions, options);
    _result = databus(parameter);
  }
  return _result;
};